export default "__VITE_ASSET__CkGOHy8d__"